import { render, staticRenderFns } from "./ActionPersonPlayer.vue?vue&type=template&id=85311f76"
import script from "./ActionPersonPlayer.vue?vue&type=script&lang=js"
export * from "./ActionPersonPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports